module.exports = __webpack_public_path__ + "img/skills.f31d012a.svg";